import React from "react";

const EnvironmentContext = React.createContext();

export default EnvironmentContext;